import { useState, useEffect, useRef } from 'react';
import Slider from 'react-slick';
import { AddNewItemModal, SlideAdd, SlideItem, Spinner } from '@shared/widgets';
import './accountsSlider.scss';
import { useGetAccountsStore } from '@lib/store';
import { AddItemEnum } from '@shared/api/rest/models';
import { AccountSlideItem, TopUpMyAccountModal } from './widgets';
import { getAccountsResponse } from '@shared/api/rest/accounts';

interface AccountSliderType {
  animate?: boolean;
  accountsPage?: boolean;
}

const settings = {
  dots: false,
  arrows: true,
  infinite: false,
  speed: 800,
  slidesToShow: 3,
  slidesToScroll: 1,
  variableWidth: false,
  adaptiveHeight: true,
  cssEase: 'ease-out',
  responsive: [
    {
      breakpoint: 768,
      settings: {
        dots: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: true,
        centerPadding: '0',
        variableWidth: false,
        adaptiveHeight: true,
      },
    },
  ],
};

export const AccountsSlider = (props: AccountSliderType) => {
  const getAccountsStore = useGetAccountsStore();

  const [slideWidth, setSlideWidth] = useState<number>(440);
  const sliderWrapRef = useRef<HTMLDivElement | null>(null);
  const sliderRef = useRef<any | null>(null);

  const [isMobile, setIsMobile] = useState<boolean>(false);
  const [slideAccount, setSlideAccount] = useState<getAccountsResponse>();
  const [isVisibleAddModal, setIsVisibleAddModal] = useState<boolean>(false);
  const [isVisibleTopModal, setIsVisibleTopModal] = useState<boolean>(false);

  useEffect(() => {
    getAccountsStore.get();
  }, []);

  useEffect(() => {
    const updateDimensions = () => {
      if (!sliderWrapRef.current || !sliderRef.current) return;

      const currentSettings = sliderRef.current.innerSlider?.props;
      const currentSlidesToShow = currentSettings.slidesToShow;

      setIsMobile(currentSlidesToShow === 1);

      const sliderWidth = sliderWrapRef.current.clientWidth;
      setSlideWidth(sliderWidth / currentSlidesToShow);
    };

    const timer = setTimeout(updateDimensions, 50);

    window.addEventListener('resize', updateDimensions);
    return () => {
      clearTimeout(timer);
      window.removeEventListener('resize', updateDimensions);
    };
  }, []);

  const width = isMobile ? slideWidth : slideWidth + (window.innerWidth > 1024 ? 22 : 14);
  const height = isMobile ? 300 : slideWidth > 350 ? 350 : slideWidth;

  return (
    <div ref={sliderWrapRef} className='-mt-2 mb-10 max-md:pb-5'>
      {!getAccountsStore.success ? (
        <div style={{ height }} className='mx-auto flex items-center'>
          <Spinner />
        </div>
      ) : (
        <Slider ref={sliderRef} className='slider-accounts sliderAnimation' {...settings}>
          {getAccountsStore.data?.map((account, idx) => {
            return (
              <SlideItem
                key={idx}
                className='h-[350px] w-[440px] cursor-pointer p-5'
                account={account}
                accountsPage={props.accountsPage}
                style={{ width, height }}
              >
                <AccountSlideItem account={account} setSlideAccount={setSlideAccount} setIsVisibleTopModal={setIsVisibleTopModal} />
              </SlideItem>
            );
          })}
          <SlideAdd
            text='Add account'
            className='h-[350px] w-[440px] cursor-pointer p-5 max-md:mb-1.5'
            style={{ width, height }}
            onClick={setIsVisibleAddModal}
          />
        </Slider>
      )}

      <AddNewItemModal isOpen={isVisibleAddModal} onClose={setIsVisibleAddModal} type={AddItemEnum.Account} />
      <TopUpMyAccountModal isOpen={isVisibleTopModal} onClose={() => setIsVisibleTopModal(false)} account={slideAccount!} />
    </div>
  );
};
